import { render, staticRenderFns } from "./ActionsHistory.vue?vue&type=template&id=52a56103&scoped=true"
import script from "./ActionsHistory.vue?vue&type=script&lang=js"
export * from "./ActionsHistory.vue?vue&type=script&lang=js"
import style0 from "./ActionsHistory.vue?vue&type=style&index=0&id=52a56103&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a56103",
  null
  
)

export default component.exports